import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EventParticipationQuestionTemplateModel } from "../models/event-participations/event-participation-question-template.model";
import { Configuration } from "src/assets/Configuration";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ParticipationQuestionTemplateService {
    
  constructor(private httpClient: HttpClient) {

  }

  public getQuestionTemplates(): Observable<EventParticipationQuestionTemplateModel[]> {
    return this.httpClient.get<EventParticipationQuestionTemplateModel[]>(
      Configuration.getApiBaseUrl() + '/participation-question-template/'
    );
  }
}